/** Global Imports */
import React, { useEffect, useContext, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter, useParams } from 'react-router-dom';

/** Component Imports */
import { styles } from './styles';
import ProgramSettings from '../program-settings';
import ProgramTeam from '../program-team';
import TabsComponent from 'components/common/tabs';

/** Context Imports */
import { userContext } from 'context/user';
import { useLoader } from 'context/loader';
import { useNotification } from 'context/notification';
import { useBreadcrumb } from 'context/breadcrumb';

/** Service Imports */
import { getProgramDetails } from 'services/programs';
import { setActiveProgram } from 'redux/actions/program';
import { collaborationRoutes } from 'router/routes';
import ProgramWorkflowLinks from '../program-workflow-links';
import useApplicationPermission from 'components/common/hooks/useCollabPermission';

function ProgramHome({ history }) {
  let classes = styles();
  const dispatch = useDispatch();
  const { dispatchLoader } = useLoader();
  const { dispatchNotification } = useNotification();
  const { currentUser } = useContext(userContext);
  const { programId } = useParams();
  const { updateBreadcrumb } = useBreadcrumb();
  const { collabSuperAdminRole } = useApplicationPermission();

  const activeProgram = useSelector(
    (state) => state.programReducer.activeProgram,
  );

  const navigateToPrograms = () => {
    history.replace('/programs');
  };

  const updateProgramDetails = useCallback(() => {
    // dispatchLoader({ show: true, message: 'Loading the program..' });
    if (programId == null) {
      navigateToPrograms();
    } else {
      return getProgramDetails(
        programId,
        currentUser.userId,
        collabSuperAdminRole !== undefined ? 0 : undefined,
      ).then((res) => {
        if (res.status === 'success') {
          dispatch(setActiveProgram(res.myProgramDetails));
          localStorage.setItem('programName', res.myProgramDetails.programName);
          updateBreadcrumb({
            key: collaborationRoutes.program.key,
            name: collaborationRoutes.program.getName(
              res.myProgramDetails.programName,
            ),
            path: collaborationRoutes.program.getPath(programId),
          });

          dispatchLoader({ show: false });
          return res;
        } else {
          dispatchLoader({ show: false });
          dispatchNotification({
            show: true,
            severity: 'error',
            message: `${res.error_message}`,
          });
          if (res.code === 401) {
            history.push(collaborationRoutes.programs.path);
          }

          return null;
        }
      });
    }
  }, [
    dispatch,
    programId,
    currentUser.userId,
    updateBreadcrumb,
    dispatchLoader,
    dispatchNotification,
  ]);

  let programDetailsTabs = [
    {
      name: 'Workflows',
      component: <ProgramWorkflowLinks programId={programId} />,
    },
    {
      name: 'Team',
      component: (
        <ProgramTeam
          programId={programId}
          updateProgramDetails={updateProgramDetails}
        />
      ),
    },
    {
      name: 'Settings',
      component: (
        <ProgramSettings
          programId={programId}
          handlePostProgramDelete={navigateToPrograms}
          updateProgramDetails={updateProgramDetails}
        />
      ),
    },
  ];

  useEffect(() => {
    updateProgramDetails();
  }, []);

  return (
    <div className={classes.root}>
      {activeProgram != undefined
        ? Object.entries(activeProgram).length > 0 && (
            <div className={classes.programMoreDetails}>
              <TabsComponent tabs={programDetailsTabs} />
            </div>
          )
        : history.push('/programs')}
    </div>
  );
}

export default withRouter(ProgramHome);
